"use client";

import { useEffect, useState } from "react";
import { Theme, useThemeStore } from "@/stores/theme";
import { useIsMobile } from "@/hooks/useIsMobile";

interface ThemeContextProps {
  theme: Theme;
  toggleTheme: () => void;
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return <>{children}</>;
}

export const useTheme = (): ThemeContextProps => {
  const theme = useThemeStore((state) => state.theme);
  const toggleTheme = useThemeStore((state) => state.toggleTheme);
  const isMobile = useIsMobile();

  useEffect(() => {
    document.documentElement.classList.toggle(
      "bg-[hsl(var(--sidebar-background))]",
      !isMobile,
    );
    document.documentElement.classList.toggle(
      "bg-[hsl(var(--background))]",
      isMobile,
    );
  }, [isMobile]);

  return {
    theme:
      theme ||
      (typeof window !== "undefined" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"),
    toggleTheme,
  };
};
